import Network from '@/common/models/network.model';
import { NetworkType, TaskState } from '@schema';
import { TaskName } from '@/common/constants/taskNames.constants';
import mapping from './wizardToBackendMapping';

const TYPES_MAPPING = {
  [NetworkType.FLAT]: 'public',
  [NetworkType.VLAN]: 'vlan',
  [NetworkType.VXLAN]: 'private'
};

export default {
  name: 'networks',
  resource: '/api/v2/compute/networks',
  Model: Network,
  socketUpdates: true,
  pagingSupport: true,
  getters: {
    getNetworksBySubnetIds: (state) => (subnetIds) => Object.values(state.itemsMap)
      .filter(it => it.subnets
        .find((subnet) => subnetIds.includes(subnet.id))),
  },
  actions: ({ resource }) => ({
    CREATE({ commit }, network) {
      const { type, network: item } = mapping(network);
      return this.$api.post(`${resource}/${type}`, item)
        .then((res) => {
          commit('CLEAR_ERRORS');
          return res;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);

          throw error;
        });
    },
    DELETE({ dispatch }, { item }) {
      return dispatch('DELETE_WITH_ASSOCIATED', { item, deleteAssociated: false });
    },
    DELETE_WITH_ASSOCIATED(store, { item, deleteAssociated = false }) {
      const { commit } = store;
      const id = item.id || item;
      const type = TYPES_MAPPING[item.originType];
      const params = item.originType !== NetworkType.VXLAN
        ? { delete_vlan_interfaces: deleteAssociated }
        : {};
      return this.$api.delete(`${resource}/${type}/${id}`, undefined, { params })
        .then((res) => {
          commit('CLEAR_ERRORS');
          if (!res.data.task_id) {
            commit('REMOVE', id);
          }
          return res;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);

          throw error;
        });
    },
    DELETE_ITEMS_WITH_ASSOCIATED({ commit, dispatch }, { items, deleteAssociated }) {
      return Promise.all(items.map(item => dispatch('DELETE_WITH_ASSOCIATED', { item, deleteAssociated })))
      .catch((error) => {
        commit('SET_ERRORS', error);

        throw error;
      });
    },
    socket_tasks({ dispatch }, { name, state, result }) {
      if (name === TaskName.COMPUTE_NETWORK_CREATE && state === TaskState.SUCCESS) {
        dispatch('FETCH_ITEM', { id: result.id, addToList: false });
      }
    }
  })
};
